import { render } from "./DocMain.vue?vue&type=template&id=26a3b5d0"
import script from "./DocMain.vue?vue&type=script&lang=js"
export * from "./DocMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__